import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getPatientFlow = asyncThunkWrapper({ 
  model: 'patientFlow', 
  action: 'getPatientFlow', 
  func: async () => {
    const attributes = ['id', 'prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/patient_flow`, { params });

    return response.data;
  } 
});
export const createPatientFlow = asyncThunkWrapper({ 
  model: 'patientFlow', 
  action: 'createPatientFlow', 
  func: async (patient_flow) => {
    const attributes = ['id', 'prompt', 'updated_at'];
    const response = await axios.post(`/patient_flow`, { patient_flow, attributes });

    return response.data;
  } 
});
export const updatePatientFlow = asyncThunkWrapper({ 
  model: 'patientFlow', 
  action: 'updatePatientFlow', 
  func: async (patient_flow) => {
    const response = await axios.patch(`/patient_flow`, { patient_flow });

    return { status: response.status, patient_flow };
  } 
});
export const deletePatientFlow = asyncThunkWrapper({ 
  model: 'patientFlow', 
  action: 'deletePatientFlow', 
  func: async () => {
    const response = await axios.delete(`/patient_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActivePatientFlow = createAction('patientFlow/clearLocalActivePatientFlow');